import * as Yup from 'yup';
import { TargetConfigMetaData } from '../models';
import Klaviyo from './index';

export const KLAVIYO_CONFIG: TargetConfigMetaData = {
  formComponent: Klaviyo,

  initialValues: {
    publicKey: '',
    privateKey: ''
  },

  validationSchema: Yup.object({
    publicKey: Yup.string().trim().required(),
    privateKey: Yup.string().trim().required()
  }),
};
